import { addDays, startOfDay } from 'date-fns'

import { normalizeEmail } from '../../Email'
import { AppointmentParticipantKind } from '../Appointment.constants'
import { getIsAppointmentReminderNone } from '../Appointment.utils'

import { APPOINTMENT_FORM_FIELD_NAME } from './AppointmentFormModal.constants'
import {
  getAppointmentFormParticipantDisplayName,
  getIsAppointmentFormParticipantExternal,
} from './AppointmentFormModal.utils.participants'

function toAppointmentFormApiDate(date) {
  return new Date(date.getTime()).toISOString()
}

function toAppointmentFormParticipantPayload(participant) {
  return getIsAppointmentFormParticipantExternal(participant)
    ? {
        display_name: getAppointmentFormParticipantDisplayName(participant),
        email: normalizeEmail(participant.email) || null,
        kind: AppointmentParticipantKind.external,
        user_profile: participant.realId ?? null,
      }
    : {
        kind: AppointmentParticipantKind.internal,
        user_profile: participant.realId,
      }
}

function getAppointmentFormSpan(values) {
  return values[APPOINTMENT_FORM_FIELD_NAME.isAllDay]
    ? {
        end: addDays(
          startOfDay(values[APPOINTMENT_FORM_FIELD_NAME.lastDay]),
          1
        ),
        start: startOfDay(values[APPOINTMENT_FORM_FIELD_NAME.firstDay]),
      }
    : {
        end: values[APPOINTMENT_FORM_FIELD_NAME.end],
        start: values[APPOINTMENT_FORM_FIELD_NAME.start],
      }
}

function getAppointmentFormReminderOffset(minutes) {
  return getIsAppointmentReminderNone(minutes) ? null : minutes
}

export function getAppointmentFormPayload({ organizerId, values }) {
  const span = getAppointmentFormSpan(values)

  return {
    appointment_type: values[APPOINTMENT_FORM_FIELD_NAME.type],
    building: values[APPOINTMENT_FORM_FIELD_NAME.building]?.value ?? null,
    description: values[APPOINTMENT_FORM_FIELD_NAME.description],
    email_thread: values[APPOINTMENT_FORM_FIELD_NAME.emailThread]?.id ?? null,
    end_at: toAppointmentFormApiDate(span.end),
    flat: values[APPOINTMENT_FORM_FIELD_NAME.flat]?.value ?? null,
    is_all_day: values[APPOINTMENT_FORM_FIELD_NAME.isAllDay],
    location: values[APPOINTMENT_FORM_FIELD_NAME.location],
    participants: [
      { kind: AppointmentParticipantKind.internal, user_profile: organizerId },
      ...values[APPOINTMENT_FORM_FIELD_NAME.participants].map(
        toAppointmentFormParticipantPayload
      ),
    ],
    reminder_offset_minutes: getAppointmentFormReminderOffset(
      values[APPOINTMENT_FORM_FIELD_NAME.reminder]
    ),
    request: values[APPOINTMENT_FORM_FIELD_NAME.request]?.value ?? null,
    resident: values[APPOINTMENT_FORM_FIELD_NAME.resident]?.id ?? null,
    start_at: toAppointmentFormApiDate(span.start),
    title: values[APPOINTMENT_FORM_FIELD_NAME.title].trim(),
  }
}
